import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

	respObject: any;
	fileData: any;
	userRole: any;
	totalRows = 0;

  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {

  	var fd = {};

  	const companyId = localStorage.getItem('companyId');
  	const userRole = localStorage.getItem('userRole');
  	
  	if (userRole=="analyst") {
  		fd["companyId"]=localStorage.getItem('companyId');
  	}
  	fd["limit"]=10;

  	this._rest.getAdminFiles(fd).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.error==0){
        this.fileData=this.respObject.resp.data;
        this.totalRows = this.respObject.resp.info;
        this.userRole = userRole;
      } else {
        this.fileData=[];
        this.userRole = userRole;
      }
    })


  }

  gotoFlashUpload(){
    this.router.navigate(['/analyst/flashUpload/']);
  }

  gotoFileUpload(){
    this.router.navigate(['/analyst/fileupload/']);
  }

  gotoFileMatrix(){
    this.router.navigate(['/admin/fileMatrix/']);
  }

  gotoUploadedFiles(){
    this.router.navigate(['/admin/filelist/']);
  }

  gotoUploadedFilesAnalyst(){
    this.router.navigate(['/analyst/viewfile/']);
  }

  gotoConsolidatedReports(){
    this.router.navigate(['/admin/consolereport/']);
  }

  gotoConsolidatedReportsAnalyst(){
      this.router.navigate(['/analyst/consoleReport/']); 
  }

  gotoCustomReports(){
    this.router.navigate(['/admin/queryreport/']);
  }

  gotoCustomReportsAnalyst(){
    this.router.navigate(['/analyst/queryreport/']);
  }

}
